import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-down-bar', 'ArrowDownBar', [["path",{"d":"M12 3v18"}],["path",{"d":"M9 18l3 3l3 -3"}],["path",{"d":"M9 3h6"}]]);